import { listScoresForPlayer } from "@dailywars/core/db";
import { createServerFn } from "@tanstack/react-start";

import { setRouteAction } from "#/lib/requestLogger.server";
import { archiveMonthKeyInputSchema } from "#/lib/serverInputSchemas";
import { resolveRequestGameContext } from "#/server/game/requestGameContext.server";
import { monthScoreQueryBounds, scoresByMapIdFromRecordsMap } from "#/server/game/scoreRecords";

export const loadArchiveMonthScores = createServerFn({ method: "GET" })
  .validator(archiveMonthKeyInputSchema)
  .handler(async ({ data }) => {
    setRouteAction("archive_month_scores");
    const { playerId } = await resolveRequestGameContext();
    const { dateFrom, dateToExclusive } = monthScoreQueryBounds(data.monthKey);
    const records = await listScoresForPlayer({ playerId, dateFrom, dateToExclusive });
    return scoresByMapIdFromRecordsMap(records);
  });
